import { cn } from '@mpange/ui';

const LOGO = '/logo.png';
const ICON = '/favicon.ico';

export function BrandLogo({
  className,
  variant = 'full',
  size = 'md',
  priority = false,
}: {
  className?: string;
  variant?: 'full' | 'mark';
  size?: 'sm' | 'md' | 'lg';
  priority?: boolean;
}) {
  const sizes = {
    sm: { full: { w: 120, h: 32 }, mark: { w: 24, h: 24 } },
    md: { full: { w: 148, h: 40 }, mark: { w: 32, h: 32 } },
    lg: { full: { w: 200, h: 54 }, mark: { w: 40, h: 40 } },
  } as const;

  const dim = sizes[size][variant];
  const src = variant === 'mark' ? ICON : LOGO;

  return (
    <img
      src={src}
      alt="MPANGE"
      width={dim.w}
      height={dim.h}
      className={cn('h-auto w-auto object-contain', className)}
      style={{ width: dim.w, height: dim.h }}
    />
  );
}
